module.exports = __webpack_public_path__ + "static/media/services_logo_unicef.658e0956.png";